const imageData = [
  {
    "id": 1,
    "title": "Plages Roses",
    "author": "Amédée Julien Marcel‑Clément",
    "description": "Olio su tela (50×61 cm), datato fine XIX‑inizio XX secolo, scena costiera, collezione privata; comparso in asta il 27 aprile 1999.",
    "imageUrl": "/paintingsimages/Amédée_Julien_Marcel-Clemént_Plages_Rose.jpg"
  },
  {
    "id": 2,
    "title": "Bird",
    "author": "Benjamin Björklund",
    "description": "Dipinto recente dell’artista svedese (nato nel 1986) che ritrae un uccello, tipico della sua poetica di animali isolati in tavolozze fredde e malinconiche.",
    "imageUrl": "/paintingsimages/Benjamin_Björklund_Bird.jpg"
  },
  {
    "id": 3,
    "title": "Frog",
    "author": "Benjamin Björklund",
    "description": "Opera raffigurante una rana, coerente con l’interesse ricorrente dell’artista per animali — cani, mucche, ratti, uccelli e rane.",
    "imageUrl": "/paintingsimages/Benjamin_Björklund_Frog.jpg"
  },
  {
    "id": 4,
    "title": "Mouse",
    "author": "Benjamin Björklund",
    "description": "Raffigura un topo; Björklund dipinge regolarmente piccoli animali, spesso evocando una sfera intima e misteriosa.",
    "imageUrl": "/paintingsimages/Benjamin_Björklund_Mouse.jpg"
  },
  {
    "id": 5,
    "title": "Tramonto",
    "author": "Camille Pissarro",
    "description": "Probabile versione del tramonto a Rouen o altro paesaggio in luce calante; Pissarro (1830–1903) fu figura di spicco dell’Impressionismo e Neo‑Impressionismo.",
    "imageUrl": "/paintingsimages/Camille_Pissarro_Tramonto.jpeg"
  },
  {
    "id": 6,
    "title": "Il sole",
    "author": "Edvard Munch",
    "description": "Dipinto espressionista (olio su tela, 1910–13 circa) raffigurante un sole ardente e paesaggio luminoso, dimensioni ca.162×205 cm.",
    "imageUrl": "/paintingsimages/Edvard_Munch_Il_sole.jpg"
  },
  {
    "id": 7,
    "title": "La Senna a Saint‑Cloud",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_La_Senna_a_Saint_Cloud.jpg"
  },
  {
    "id": 8,
    "title": "Notte Stellata",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_Notte_Stellata.jpg"
  },
  {
    "id": 9,
    "title": "Moonlight",
    "author": "Edward Moran",
    "description": null,
    "imageUrl": "/paintingsimages/Edward_Moran_Moonlight.png"
  },
  {
    "id": 10,
    "title": "Levitation",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Levitation.jpg"
  },
  {
    "id": 11,
    "title": "Memoir",
    "author": "Fan Ho",
    "description": null,
    "imageUrl": "/paintingsimages/Fan_Ho_Memoir.jpg"
  },
  {
    "id": 12,
    "title": "La danzatrice spagnola",
    "author": "Giovanni Boldini",
    "description": null,
    "imageUrl": "/paintingsimages/Giovanni_Boldini_La_danzatrice_spagnola.jpg"
  },
  {
    "id": 13,
    "title": "Death and Life",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Gustav_Klimt_Death_and_Life.jpg"
  },
  {
    "id": 14,
    "title": "Case of The Footloose Doll",
    "author": "James R. Bingham",
    "description": null,
    "imageUrl": "/paintingsimages/James_R_Bingham_Case_of_The_Footloose_Doll.jpg"
  },
  {
    "id": 15,
    "title": "NYC",
    "author": "Jeremy Mann",
    "description": null,
    "imageUrl": "/paintingsimages/Jeremy_Mann_NYC.jpg"
  },
  {
    "id": 16,
    "title": "Mattina Invernale",
    "author": "Joseph Farquharson",
    "description": null,
    "imageUrl": "/paintingsimages/Joseph_Farquharson_Mattina_Invernale.png"
  },
  {
    "id": 17,
    "title": "Stadttheater und Alleestraße",
    "author": "Ludvig Munthe",
    "description": null,
    "imageUrl": "/paintingsimages/Ludvig_Munthe_Stadttheater_und_Alleestraße.jpg"
  },
  {
    "id": 18,
    "title": "Sopra la città",
    "author": "Marc Chagall",
    "description": null,
    "imageUrl": "/paintingsimages/Marc_Chagall_Sopra_la_città.png"
  },
  {
    "id": 19,
    "title": "Alone Together",
    "author": "Maria Kreyn",
    "description": null,
    "imageUrl": "/paintingsimages/Maria_Kreyn_Alone_Together.jpg"
  },
  {
    "id": 20,
    "title": "Il pittore e la modella",
    "author": "Milo Manara",
    "description": null,
    "imageUrl": "/paintingsimages/Milo_Manara_Il_pittore_e_la_modella.jpg"
  },
  {
    "id": 21,
    "title": "L'onda",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Munch_Edvard_L'onda.jpg"
  },
  {
    "id": 22,
    "title": "The waves of love",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Munch_The_waves_of_love.png"
  },
  {
    "id": 23,
    "title": "Il vecchio chitarrista cieco",
    "author": "Pablo Picasso",
    "description": null,
    "imageUrl": "/paintingsimages/Picasso_Il_vecchio_chitarrista_cieco.jpg"
  },
  {
    "id": 24,
    "title": "L'Etreinte",
    "author": "Pablo Picasso",
    "description": null,
    "imageUrl": "/paintingsimages/Picasso_L'Etreinte.png"
  },
  {
    "id": 25,
    "title": "Le cabinet anthropomorphique",
    "author": "Salvador Dalí",
    "description": null,
    "imageUrl": "/paintingsimages/Salvador_Dali_Le_cabinet_anthropomorphique.jpg"
  },
  {
    "id": 26,
    "title": "PALLADIOS CORRIDOR OF THALIA",
    "author": "Salvador Dalì",
    "description": null,
    "imageUrl": "/paintingsimages/Salvador_Dalì_PALLADIOS_CORRIDOR_OF_THALIA.jpg"
  },
  {
    "id": 27,
    "title": "The Poor and Money",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/The_Poor_and_Money_Vincent_van_Gogh.jpg"
  },
  {
    "id": 28,
    "title": "Trasparenze",
    "author": "Vicente Romero Redondo",
    "description": null,
    "imageUrl": "/paintingsimages/Vicente_Romero_Redondo_Trasparenze.jpg"
  },
  {
    "id": 29,
    "title": "Country Road",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Vincent_van_Gogh_Country_Road.jpg"
  },
  {
    "id": 30,
    "title": "Notte stellata",
    "author": "Vincent van Gogh",
    "description": "Olio su tela, giugno 1889; raffigura il cielo notturno da Saint‑Rémy‑de‑Provence, con vortici blu‑gialli, cipressi fiammeggianti e villaggio, icona moderna custodita al MoMA.",
    "imageUrl": "/paintingsimages/Vincent_van_Gogh_Notte_stellata.png"
  },
  {
    "id": 31,
    "title": "Tempesta di neve. Battello a vapore al largo di Harbour's Mouth",
    "author": "William Turner",
    "description": null,
    "imageUrl": "/paintingsimages/William_Turner_Tempesta_di_neve_Battello_a_vapore_al_largo_di_Harbour's_Mouth.jpg"
  },
    {
    "id": 32,
    "title": "Death and the Maiden",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Death_and_the_Maiden.jpg"
  },
  {
    "id": 33,
    "title": "Female Nude Lying on Her Stomach",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Female_Nude_Lying_on_Her_Stomach.jpg"
  },
  {
    "id": 34,
    "title": "Female Nude",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Female_nude.jpg"
  },
  {
    "id": 35,
    "title": "Fighter",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Fighter.jpg"
  },
  {
    "id": 36,
    "title": "Harbor of Trieste",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Harbor_of_Trieste.jpg"
  },
  {
    "id": 37,
    "title": "Kneeling Female Nude",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Kneeling_Female_Nude.jpg"
  },
  {
    "id": 38,
    "title": "Kneeling Girl",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Kneeling_Girl.jpg"
  },
  {
    "id": 39,
    "title": "Man Bending Down Deeply",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Man_Bendind_Down_Deeply.jpg"
  },
  {
    "id": 40,
    "title": "Old Houses in Krumau",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Old_Houses_in_Krumau.jpg"
  },
  {
    "id": 41,
    "title": "Pair Embracing",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Pair_embracing.jpg"
  },
  {
    "id": 42,
    "title": "Quattro Alberi",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Quattro_alberi.JPEG"
  },
  {
    "id": 43,
    "title": "Seated Woman with Bent Knee",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Seated_Woman_with_Bent_Knee.jpg"
  },
  {
    "id": 44,
    "title": "Seated Female Nude with Elbows Propped",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Seated_female_nude_with_elbows_propped.jpg"
  },
  {
    "id": 45,
    "title": "Standing Girl in a Blue Dress and Green Stockings",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Standing_Girl_in_a_Blue_Dress_and_Green_Stockings.jpg"
  },
  {
    "id": 46,
    "title": "Standing Girl in a Plaid Garment",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Standing_Girl_in_a_Plaid_Garment.jpg"
  },
  {
    "id": 47,
    "title": "Standing Male Nude",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Standing_Male_Nude.jpg"
  },
  {
    "id": 48,
    "title": "The Green Stocking",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_The_Green_Stocking.jpg"
  },
  {
    "id": 49,
    "title": "Trees Mirrored in a Pond",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Trees_Mirrored_in_a_Pond.jpg"
  },
  {
    "id": 50,
    "title": "Woman Undressing",
    "author": "Egon Schiele",
    "description": null,
    "imageUrl": "/paintingsimages/Egon_Schiele_Woman_Undressing.jpg"
  },
  {
    "id": 51,
    "title": "Il bacio",
    "author": "Francesco Hayez",
    "description": null,
    "imageUrl": "/paintingsimages/Francesco_Hayez_Il_bacio.jpg"
  },
  {
    "id": 52,
    "title": "Il bacio in bianco",
    "author": "Francesco Hayez",
    "description": null,
    "imageUrl": "/paintingsimages/Francesco_Hayez_Il_bacio_in_bianco.jpg"
  },
  {
    "id": 53,
    "title": "Notturno",
    "author": "Gurutze Ramos",
    "description": null,
    "imageUrl": "/paintingsimages/Gurutze_Ramos_Notturno.jpg"
  },
  {
    "id": 54,
    "title": "Nighthawks",
    "author": "Edward Hopper",
    "description": null,
    "imageUrl": "/paintingsimages/Hopper_Nighthawks.jpg"
  },
  {
    "id": 55,
    "title": "Danaë",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Danaë.jpg"
  },
  {
    "id": 56,
    "title": "Death and Life",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Death_and_life.jpg"
  },
  {
    "id": 57,
    "title": "Fabel",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Fabel.jpg"
  },
  {
    "id": 58,
    "title": "Forest Floor",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Forest_floor.jpg"
  },
  {
    "id": 59,
    "title": "Goldfish",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Goldfish.jpg"
  },
  {
    "id": 60,
    "title": "Hope",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Hope.jpg"
  },
  {
    "id": 61,
    "title": "Il bacio",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Il_bacio.jpg"
  },
  {
    "id": 62,
    "title": "Lady With Hat and Feather Boa",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Lady_With_Hat_and_Feather_Boa.jpg"
  },
  {
    "id": 63,
    "title": "Mother with Two Children",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Mother_with_Two_Children.jpg"
  },
  {
    "id": 64,
    "title": "Musik",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Musik.jpeg"
  },
  {
    "id": 65,
    "title": "On Lake Attersee",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_On_Lake_Attersee.jpg"
  },
  {
    "id": 66,
    "title": "Portrait of Adele Bloch-Bauer",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Portrait_of_Adele_Bloch_Bauer.jpg"
  },
  {
    "id": 67,
    "title": "Portrait of Elisabeth Lederer",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Portrait_of_Elisabeth_Lederer.jpg"
  },
  {
    "id": 68,
    "title": "Portrait of Emilie Flöge",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Portrait_of_Emilie_Flöge.jpg"
  },
  {
    "id": 69,
    "title": "Sitting Nude Man Turned to the Left",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Sitting_Nude_Man_Turned_to_the_Left.jpg"
  },
  {
    "id": 70,
    "title": "The Black Feathered Hat",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_The_Black_Feathered_Hat.jpg"
  },
  {
    "id": 71,
    "title": "The Maiden",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_The_Maiden.jpg"
  },
  {
    "id": 72,
    "title": "The Three Ages of Woman",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_The_Three_Ages_of_Woman.jpg"
  },
  {
    "id": 73,
    "title": "Water Nymphs",
    "author": "Gustav Klimt",
    "description": null,
    "imageUrl": "/paintingsimages/Klimt_Water_Nymphs.jpg"
  },
  {
    "id": 74,
    "title": "Autunno",
    "author": "Gavriil Pavlovich Kondratenko",
    "description": null,
    "imageUrl": "/paintingsimages/Kondratenko_Gavriil_Pavlovich_Autunno.JPEG"
  },
  {
    "id": 75,
    "title": "Girl with Umbrella",
    "author": "Manisha",
    "description": null,
    "imageUrl": "/paintingsimages/Manisha_Girl_with_umbrela.jpg"
  },
  {
    "id": 76,
    "title": "Night",
    "author": "Mariana Pandele",
    "description": null,
    "imageUrl": "/paintingsimages/Mariana_Pandele_Night.jpg"
  },
  {
    "id": 77,
    "title": "La Lille",
    "author": "Meixiaozengshan",
    "description": null,
    "imageUrl": "/paintingsimages/Meixiaozengshan_La_Lille.jpg"
  },
  {
    "id": 78,
    "title": "Window",
    "author": "Obey Nada",
    "description": null,
    "imageUrl": "/paintingsimages/Obey_Nada_Window.jpg"
  },
  {
    "id": 79,
    "title": "Nu bleu",
    "author": "Pablo Picasso",
    "description": null,
    "imageUrl": "/paintingsimages/Picasso_Nu_bleu.JPEG"
  },
  {
    "id": 80,
    "title": "Casino",
    "author": "Robert Hoppe",
    "description": null,
    "imageUrl": "/paintingsimages/Robert_Hoppe_Casino.jpg"
  },
  {
    "id": 81,
    "title": "Murder Mystery",
    "author": "Robert McGinnis",
    "description": null,
    "imageUrl": "/paintingsimages/Robert_McGinnis_Murder_Mystery.jpg"
  },
  {
    "id": 82,
    "title": "Notturno",
    "author": "Stephanie Turner",
    "description": null,
    "imageUrl": "/paintingsimages/Stephanie_Turner_Notturno.jpg"
  },
  {
    "id": 83,
    "title": "Untitled",
    "author": "Tatsuro Kiuchi",
    "description": null,
    "imageUrl": "/paintingsimages/Tatsurokiuchi_Untitled.jpg"
  },
  {
    "id": 84,
    "title": "Animals",
    "author": "Tide Lie",
    "description": null,
    "imageUrl": "/paintingsimages/Tide_Lie_Animals.jpg"
  },
  {
    "id": 85,
    "title": "Jazz Bar",
    "author": "Unknown",
    "description": null,
    "imageUrl": "/paintingsimages/Unknown_Jazz_Bar.jpg"
  },
    {
    "id": 86,
    "title": "Albero battuto dal vento",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Albero_battuto_dal_vento.jpeg"
  },
  {
    "id": 87,
    "title": "Barcaioli ad Arles",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Barcaioli_ad_Arles.jpeg"
  },
  {
    "id": 88,
    "title": "Casa di campagna con alberi",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Casa_di_campagna_con_alberi.jpeg"
  },
  {
    "id": 89,
    "title": "Contadino che brucia l'erba",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Contadino_che_brucia_l'erba.jpeg"
  },
  {
    "id": 90,
    "title": "Der Garten des Dichters",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Der_Garten_des_Dichters.jpeg"
  },
  {
    "id": 91,
    "title": "Due donne nel bosco",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Due_donne_nel_bosco.jpeg"
  },
  {
    "id": 92,
    "title": "Due granchi",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Due_granchi.jpeg"
  },
  {
    "id": 93,
    "title": "Falena",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Falena.jpeg"
  },
  {
    "id": 94,
    "title": "Fine della giornata di lavoro",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Fine_della_giornata_di_lavoro.jpeg"
  },
  {
    "id": 95,
    "title": "Gelso",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Gelso.jpeg"
  },
  {
    "id": 96,
    "title": "Giardino del Vicariato sotto la neve",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Giardino_del_Vicariato_sotto_la_neve.jpeg"
  },
  {
    "id": 97,
    "title": "Il mare a Saintes Maries",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Il_mare_a_Saintes_Maries.jpeg"
  },
  {
    "id": 98,
    "title": "Il seminatore",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Il_seminatore.jpeg"
  },
  {
    "id": 99,
    "title": "La ronda dei carcerati",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_La_ronda_dei_carcerati.jpeg"
  },
  {
    "id": 100,
    "title": "Martin Pescatore",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Martin_Pescatore.jpeg"
  },
  {
    "id": 101,
    "title": "Montagne presso Saint-Rémy",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Montagne_presso_Saint_Rémy.jpeg"
  },
  {
    "id": 102,
    "title": "Notte stellata sul Rodano",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Notte_stellata_sul_Rodano.jpeg"
  },
  {
    "id": 103,
    "title": "Paesaggio con salici",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Paesaggio_con_salici.jpeg"
  },
  {
    "id": 104,
    "title": "Panorama con chiesa al crepuscolo",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Panorama_con_chiesa_al_crepuscolo.jpeg"
  },
  {
    "id": 105,
    "title": "Panorama con dune e figure",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Panorama_con_dune_e_figure.jpeg"
  },
  {
    "id": 106,
    "title": "Ragazza nel bosco",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Ragazza_nel_bosco.jpg"
  },
  {
    "id": 107,
    "title": "Rose selvatiche",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Rose_selvatiche.jpeg"
  },
  {
    "id": 108,
    "title": "Spiaggia di Scheveningen",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Spiaggia_di_scheveningen.jpeg"
  },
  {
    "id": 109,
    "title": "Sulla soglia dell'eternità",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Sulla_soglia_dell'eternità.jpeg"
  },
  {
    "id": 110,
    "title": "Terrazza del caffè la sera",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Terrazza_del_caffè_la_sera.jpeg"
  },
  {
    "id": 111,
    "title": "Tre figure vicino a un canale con mulino sullo sfondo",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Tre_figure_vicino_a_un_canale_con_mulino_sullo_sfondo.jpeg"
  },
  {
    "id": 112,
    "title": "Uliveto",
    "author": "Vincent van Gogh",
    "description": null,
    "imageUrl": "/paintingsimages/Van_Gogh_Uliveto.jpeg"
  },
  {
    "id": 113,
    "title": "Night Walk",
    "author": "Елена Муринович",
    "description": null,
    "imageUrl": "/paintingsimages/Елена_Муринович_Night_walk.jpg"
  },
  {
    "id": 114,
    "title": "Untitled",
    "author": "Дмитрий Бусырев",
    "description": null,
    "imageUrl": "/paintingsimages/Дмитрий_Бусырев_Untitled.jpg"
  },
    {
    "id": 115,
    "title": "Despair",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_Despair.jpg"
  },
  {
    "id": 116,
    "title": "Evening on Karl Johan Street",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_Evening_on_Karl_Johan_Street.jpg"
  },
  {
    "id": 117,
    "title": "Girl and Death",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_Girl_and_Death.jpg"
  },
  {
    "id": 118,
    "title": "Kiss",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_Kiss.jpg"
  },
  {
    "id": 119,
    "title": "Man and Woman",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_Man_and_Woman.jpg"
  },
  {
    "id": 120,
    "title": "Starry Night",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_Starry_night.jpg"
  },
  {
    "id": 121,
    "title": "The Flower of Pain",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_The_Flower_of_Pain.jpg"
  },
  {
    "id": 122,
    "title": "The Sick Child",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_The_Sick_Child.jpg"
  },
  {
    "id": 123,
    "title": "The Women",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_The_Women.jpg"
  },
  {
    "id": 124,
    "title": "The Scream",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_The_scream.jpg"
  },
  {
    "id": 125,
    "title": "Vampire II",
    "author": "Edvard Munch",
    "description": null,
    "imageUrl": "/paintingsimages/Edvard_Munch_Vampire_II.jpg"
  }
]
;

export default imageData;